// import { ICMS, ICMSIMAGE } from "../screens/home/homeModel";

export function formatIndianNumber(number: number, decimal: any = 2): string {
  if (number === null || number === undefined) return "";
  let [integerPart, decimalPart] = number.toFixed(decimal).split(".");
  let lastThreeDigits = integerPart.slice(-3);
  let otherDigits = integerPart.slice(0, -3);

  if (otherDigits !== "") {
    lastThreeDigits = "," + lastThreeDigits;
  }

  let formattedOtherDigits = otherDigits.replace(/\B(?=(\d{2})+(?!\d))/g, ",");
  return formattedOtherDigits + lastThreeDigits + "." + decimalPart;
}

export const formatCurrency = (amount: number) => {
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
};

export function createLookupObject<
  T extends Record<string, any>,
  K extends keyof T,
>(array: T[], key: K): Record<T[K] & (string | number | symbol), T> {
  const lookup: Record<string | number | symbol, T> = {};

  for (const item of array) {
    lookup[item[key] as any] = item;
  }

  return lookup as Record<T[K] & (string | number | symbol), T>;
}

export const calculateReadingTime = (
  text: string,
  wordsPerMinute = 150,
): string => {
  if (!text) return "1 min read";

  // Remove HTML tags if present
  const cleanText = text.replace(/<[^>]*>/g, "");

  // Count words (split by spaces and filter out empty strings)
  const wordCount = cleanText
    .trim()
    .split(/\s+/)
    .filter((word) => word.length > 0).length;

  // Calculate reading time in minutes
  const minutes = Math.ceil(wordCount / wordsPerMinute);

  // Return formatted string
  return `${Math.max(1, minutes)} min read`;
};

export function decodeHtml(html: string): string {
  if (!html) return "";
  if (typeof document === "undefined") return html;
  const txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
}

export function generateValueLabelRange<T extends number | string>(
  start: number,
  end: number,
  as: "number" | "string",
): { value: T; label: T }[] {
  const result: { value: T; label: T }[] = [];

  for (let i = start; i <= end; i++) {
    const val = (as === "string" ? String(i) : i) as T;
    result.push({ value: val, label: val });
  }

  return result;
}

export const isValidImgSrc = (src: any): boolean => {
  if (!src || typeof src !== "string") return false;
  const trimmed = src.trim();
  return (
    trimmed !== "" &&
    trimmed !== "null" &&
    trimmed !== "undefined" &&
    !trimmed.includes("undefined")
  );
};

export const getSessionId = (): string => {
  if (typeof window === "undefined") return "";
  let sessionId = sessionStorage.getItem("sou_session_id");
  if (!sessionId) {
    sessionId = crypto.randomUUID();
    sessionStorage.setItem("sou_session_id", sessionId);
  }
  return sessionId;
};

/**
 * Strips <title>, <meta>, and <link> tags from HTML strings.
 * This is used to prevent meta tags from the CMS from appearing in the body.
 */
export const cleanHeaderTags = (html: string): string => {
  if (!html) return "";
  return html
    .replace(/<title[^>]*>[\s\S]*?<\/title>/gi, "")
    .replace(/<meta[^>]*>/gi, "")
    .replace(/<link[^>]*>/gi, "");
};
